import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M4 30V0H2v5H0v2h2v3H0v2h2v3H0v2h2v3H0v2h2v3H0v2h2v4a1 1 0 001 1h29v-2H4z"></path>
          <path d="M28 8h-5v2h2.586L17 18.586l-2.293-2.293a.999.999 0 00-1.414 0l-5 5 1.414 1.414L14 18.414l2.293 2.293a.999.999 0 001.414 0L27 11.414V14h2V9a1 1 0 00-1-1z"></path>
        </svg>
    );
}